import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../../Contexts/AppContext";
import { AccordionItem } from "../../Elements/Accordion";
import { TocWidget } from "../Toc/TocWidget";
import { Authorization } from "./Authorization";
import { CustomerInfo } from "./CustomerInfo";
import { SheetSelector } from "./SheetSelector";

export const MapDownloadWidget = (): JSX.Element => {
    const { activeToken } = useAppContext();
    const [showAuthorization, setShowAuthorization] = useState<boolean>(!activeToken);

    useEffect(() => {
        // this is to prevent immediate remove of Authorization component from from DOM, as it cause errors
        activeToken && setTimeout(() => setShowAuthorization(false), 0);
    }, [activeToken]);
    return (
        <>
            <CustomerInfo />
            <AccordionItem
                title={i18next.t("toolBar.toc")}
                class={"second-toc"}
                changeHeight={Math.random()}
                defaultExpanded={11}
                key="subtoc"
            >
                <TocWidget mainToc={false} />
            </AccordionItem>
            <AccordionItem
                title={i18next.t("toolBar.mapDownload")}
                class={"authorization-widget"}
                changeHeight={Math.random()}
                defaultExpanded={11}
                key="mapdownloadpart"
            >
                {showAuthorization ? <Authorization /> : <SheetSelector />}
            </AccordionItem>
        </>
    );
};
